<div class="mx-auto md:px-4">
  <!-- Toolbar: title + counts · status tabs + view/tenant -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-5">
    <!-- Title + counts -->
    <div>
      <h1 class="text-xl font-semibold text-gray-900">Projects</h1>
      <p class="text-sm text-gray-400 mt-0.5">
        {{ activeProjectsCount }} active · {{ doneProjectsCount }} done@if(archivedProjectsCount > 0) { · {{ archivedProjectsCount }} archived }
      </p>
    </div>

    <div class="flex items-center gap-2">
      <!-- Scope tabs: admins toggle All / Assigned to me; non-admins only see their own -->
      @if(user.admin()) {
      <div class="inline-flex rounded-lg bg-gray-100 p-0.5">
        <button (click)="onScopeTab('all')" class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors"
          [ngClass]="scopeFilter === 'all' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">All</button>
        <button (click)="onScopeTab('mine')" class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors"
          [ngClass]="scopeFilter === 'mine' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">Assigned to me</button>
      </div>
      } @else {
      <span class="inline-flex items-center px-3 py-1.5 rounded-lg bg-gray-100 text-sm font-medium text-gray-600">Assigned to me</span>
      }

      <!-- Lifecycle filter. Default hides archived projects. -->
      <div class="relative shrink-0">
        <select [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()"
          class="appearance-none pl-3 pr-8 py-2 rounded-lg text-sm font-medium text-gray-600
                 bg-transparent border border-transparent cursor-pointer max-w-[10rem] truncate
                 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/15 transition-all">
          <option value="">All (excl. archived)</option>
          <option value="ACTIVE">In progress</option>
          <option value="STANDBY">Stand-by</option>
          <option value="DONE">Done</option>
          <option value="ARCHIVED">Archived</option>
        </select>
        <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
          stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      <!-- Tenant Filter (admin or multi-tenant user) -->
      @if(showTenantFilter) {
      <div class="relative shrink-0">
        <select [(ngModel)]="selectedTenantId" (ngModelChange)="onTenantFilterChange()"
          class="appearance-none pl-3 pr-8 py-2 rounded-lg text-sm font-medium text-gray-600
                 bg-transparent border border-transparent cursor-pointer max-w-[10rem] truncate
                 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/15 transition-all">
          <option value="">{{ user.admin() ? 'All Tenants' : 'All my Tenants' }}</option>
          @for(tenant of tenants; track tenant.id) {
          <option [value]="tenant.id">{{ tenant.name }}</option>
          }
        </select>
        <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none"
          stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      }
    </div>
  </div>

  <!-- Content area -->
  @if(isLoading) {
  <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
    <div class="space-y-4 animate-pulse">
      @for(i of [1, 2, 3]; track i) {
      <div class="border border-gray-100 rounded-xl p-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 bg-gray-200 rounded-lg"></div>
            <div>
              <div class="h-4 w-36 bg-gray-200 rounded mb-2"></div>
              <div class="flex gap-2">
                <div class="h-5 w-16 bg-gray-100 rounded-full"></div>
                <div class="h-5 w-12 bg-gray-100 rounded-full"></div>
              </div>
            </div>
          </div>
          <div class="w-6 h-6 bg-gray-100 rounded"></div>
        </div>
        <div class="mt-3 flex items-center gap-2">
          <div class="h-3 w-12 bg-gray-100 rounded"></div>
          <div class="flex -space-x-2">
            <div class="w-7 h-7 bg-gray-200 rounded-full border-2 border-white"></div>
            <div class="w-7 h-7 bg-gray-200 rounded-full border-2 border-white"></div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-4">
    <app-project-list class="block" [projects]="projects" (projectClick)="goToDetail($event)"></app-project-list>
  </div>
  }
</div>

<!-- Add Stage Modal -->
@if(showAddStageModal && selectedProjectIdForNewStage) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm p-4"
  (click)="showAddStageModal = false">
  <div (click)="$event.stopPropagation()" class="w-full flex justify-center">
    <app-add-stage-project [preselectedProjectId]="selectedProjectIdForNewStage"
      [projectStartDate]="selectedProjectStartDate || undefined" (close)="showAddStageModal=false">
    </app-add-stage-project>
  </div>
</div>
}